<template>
  <Modal position="end" width="46.25rem" ref="modalRef">
    <template #header>Photos</template>
    <template #body>
      <PropertyImagesEdit title="Edit your photos" ref="propertyImagesEditRef" />
    </template>
    <template #footer>
      <Button :disabled="isUploading" :loading="imagesStore.isSaving" @click="updateImagesOrder">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Button, Modal } from '@tallo/design-system';
import { usePropertyImagesStore, PropertyImagesEdit } from '@tallo/investor/property';

const imagesStore = usePropertyImagesStore();
const modalRef = ref<InstanceType<typeof Modal>>();
const propertyImagesEditRef = ref<InstanceType<typeof PropertyImagesEdit>>();
const isUploading = computed(() => propertyImagesEditRef.value?.isUploading);

async function updateImagesOrder() {
  await imagesStore.updateImagesOrder();
  modalRef.value?.close();
}

defineExpose({ modalRef });
</script>

<style scoped lang="scss"></style>
